// extracted by mini-css-extract-plugin
export default {"title-section":"_1J-jbn70KC","titleSection":"_1J-jbn70KC","tabs":"Co9x5ofogc"};
    if(module.hot) {
      // 1625219481969
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  